import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginPage:'login',
    userData:{},
    gameInfo:"",
    haslogin:false,
    gameName:"",
    asset:{

    }
  },
  mutations: {
    logout(state){
      state.haslogin = false;
      state.userData = "";
      window.sessionStorage.clear("userData");
      window.sessionStorage.clear("loginTime");
      window.sessionStorage.clear("asset");
    },
    setAsset(state,data){
      state.asset = data;
      window.sessionStorage.setItem("asset",JSON.stringify(data));
    },
    setPage(state,data){
      state.loginPage = data
    },
    setUser(state,data,logout){
    //  data.gid =43236257;
      state.userData = data;
      window.sessionStorage.setItem("userData",JSON.stringify(data));
      window.sessionStorage.setItem("loginTime",String(new Date().getTime()));
    },
    setLoginState(state,data){
      state.haslogin = data
    },
    setGameInfo(state,data){
      state.gameInfo = data;
    },
    setGameName(state,data){
      state.gameName = data;
    }
  },
  actions: {

  }
})
